import { IconFormNames } from 'shared/assets/icons';
import { OnboardingLifeArea } from 'shared/types/onboarding-answers';

export const lifeAreas: OnboardingLifeArea[] = [
  {
    id: 'work_and_career',
    name: { en: 'Work & Career', nl: 'Werk & Carrière' },
    iconName: IconFormNames.WorkAndCareer,
    color: '#066DFE',
  },
  {
    id: 'sport_and_health',
    name: { en: 'Sport & Health', nl: 'Sporten & Gezondheid' },
    iconName: IconFormNames.SportAndHealth,
    color: '#FF6B1C',
  },
  {
    id: 'love_and_relationships',
    name: { en: 'Love & Relationships', nl: 'Liefde & Relaties' },
    iconName: IconFormNames.LoveAndRelationships,
    color: '#FA2835',
  },
  {
    id: 'money_and_finance',
    name: { en: 'Money & Finance', nl: 'Geld & Financiën' },
    iconName: IconFormNames.MoneyAndFinance,
    color: '#07C49B',
  },
  {
    id: 'personal_development',
    name: { en: 'Personal development', nl: 'Persoonlijke ontwikkeling' },
    iconName: IconFormNames.PersonalDevelopment,
    color: '#8875FB',
  },
  {
    id: 'education_and_learning',
    name: { en: 'Education & Learning', nl: 'Studie & Leren' },
    iconName: IconFormNames.EducationAndLearning,
    color: '#599EFF',
  },
  {
    id: 'fun_and_relaxation',
    name: { en: 'Fun & Relaxation', nl: 'Plezier & Ontspanning' },
    iconName: IconFormNames.FunAndRelaxation,
    color: '#F7B10C',
  },
  {
    id: 'family_and_friends',
    name: { en: 'Family & Friends', nl: 'Familie & Vrienden' },
    iconName: IconFormNames.FamilyAndFriends,
    color: '#6A6693',
  },
  {
    id: 'spirituality',
    name: { en: 'Spirituality', nl: 'Spiritualiteit' },
    iconName: IconFormNames.Spirituality,
    color: '#86C2B6',
  },
];

export const lifeAreaIds = lifeAreas.map(({ id }) => id);
